import { AuditAPI } from './audit-api';
import { FragmentsAPI } from './fragments-api';
import { ReportsAPI } from './reports-api';

/**
 * Defines the legacy API modules used exclusively by the main application.
 */
export const apiModules = {
  audit: AuditAPI,
  fragments: FragmentsAPI,
  reports: ReportsAPI,
};
